import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";
import { translations } from "@/i18n/translations";

const FooterSection = () => {
  const { t, lang } = useLanguage();
  const s = t(translations.footer);
  const leadershipLabel = lang === "ar" ? "قيادة رنين" : "Leadership";
  const partnersLabel = lang === "ar" ? "برنامج الشركاء" : "Partners Program";

  return (
    <footer className="bg-foreground text-background">
      {/* Start Selling CTA */}
      <div className="border-b border-muted-foreground/20">
        <div className="container mx-auto px-5 py-10 md:py-12 text-center">
          <h3 className="text-xl md:text-3xl font-bold mb-2 md:mb-3">{s.startSellingTitle}</h3>
          <p className="text-background/70 mb-4 text-xs md:text-base">{s.startSellingText}</p>
          <Button size="lg" className="rounded-md px-8 md:px-10 font-bold mb-3 text-sm md:text-base" asChild>
            <Link to={`/${lang}/sell/register`}>{s.startSellingCta}</Link>
          </Button>
          <p className="text-background/50 text-[11px] md:text-sm">{s.limitedOffer}</p>
        </div>
      </div>

      {/* Help */}
      <div className="border-b border-muted-foreground/20">
        <div className="container mx-auto px-5 py-10 md:py-12 text-center">
          <h3 className="text-xl md:text-3xl font-bold mb-2 md:mb-3">{s.helpTitle}</h3>
          <p className="text-background/70 mb-5 md:mb-6 text-xs md:text-base">{s.helpText}</p>
          <Button size="lg" variant="outline" className="rounded-md px-8 md:px-10 font-bold border-background/30 text-background bg-transparent hover:bg-background/10 hover:text-background text-sm md:text-base">
            {s.contactCta}
          </Button>
        </div>
      </div>

      {/* Newsletter */}
      <div className="border-b border-muted-foreground/20">
        <div className="container mx-auto px-5 py-6 md:py-8 flex flex-col md:flex-row items-center gap-3 md:gap-4 justify-between">
          <h4 className="font-bold text-sm md:text-lg">{s.newsletterTitle}</h4>
          <div className="flex gap-2 w-full md:w-auto">
            <Input
              type="email"
              aria-label={s.newsletterTitle}
              placeholder={s.emailPlaceholder}
              className="bg-background/10 border-background/20 text-background placeholder:text-background/40 md:w-72 text-sm"
            />
            <Button variant="outline" className="border-background/30 text-background bg-transparent hover:bg-background/10 hover:text-background font-bold text-sm shrink-0">
              {s.subscribe}
            </Button>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="container mx-auto px-5 py-5 md:py-6 flex flex-col md:flex-row items-center justify-between gap-3 md:gap-4">
        <p className="text-2xl md:text-3xl font-black text-primary">رنين<span className="text-background">.كوم</span></p>
        <div className="flex items-center gap-4 text-xs md:text-sm text-background/50">
          <Link to={`/${lang}/leadership`} className="hover:text-background/70">{leadershipLabel}</Link>
          <Link to={`/${lang}/partners-program`} className="hover:text-background/70">{partnersLabel}</Link>
          <Link to={`/${lang}/retail`} className="hover:text-background/70">{s.brandsProgram}</Link>
          <a href="#" className="hover:text-background/70">{s.privacyNotice}</a>
          <a href="#" className="hover:text-background/70">{s.termsOfUse}</a>
        </div>
        <p className="text-xs md:text-sm text-background/50">© {new Date().getFullYear()} {s.rights}</p>
      </div>
    </footer>
  );
};

export default FooterSection;
